import React from 'react';
import ConfigurationFormComponent from './ConfigurationForm';
import { useParams } from 'react-router-dom';

export default function EditConfiguration() {
  let { id } = useParams();
  return <ConfigurationFormComponent id={id} />;
}
